import { ChangeDetectionStrategy, Component, ContentChild, forwardRef, Inject, input } from '@angular/core';
import { CdkStep } from '@angular/cdk/stepper';
import { SutStepLabelDirective } from './step-label';
import { SutStepperComponent } from './stepper.component';
import { TemplatePortal, CdkPortalOutlet } from '@angular/cdk/portal';
import { GqlSeverity } from '../../graphql/base-types.graphql';

@Component({
  selector: 'sut-step', // eslint-disable-line @angular-eslint/component-selector
  templateUrl: './step.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: CdkStep, useExisting: SutStepComponent }],
  imports: [CdkPortalOutlet],
})
export class SutStepComponent extends CdkStep {
  @ContentChild(SutStepLabelDirective)
  override stepLabel: SutStepLabelDirective;
  severity = input<GqlSeverity>();
  stepName = input<string>();

  get name() {
    return this.stepName();
  }

  _portal: TemplatePortal;

  constructor(@Inject(forwardRef(() => SutStepperComponent)) stepper: SutStepperComponent) {
    super(stepper);
  }
}
